import { render, staticRenderFns } from "./Soon.vue?vue&type=template&id=5d49b6e2&scoped=true&"
import script from "./Soon.vue?vue&type=script&lang=js&"
export * from "./Soon.vue?vue&type=script&lang=js&"
import style0 from "./Soon.vue?vue&type=style&index=0&id=5d49b6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49b6e2",
  null
  
)

export default component.exports